import ScheduleTourForm from '@/components/ScheduleTourForm/ScheduleTourForm';
import type { Unit } from '@/domain/units';
import type { FC } from 'react';
import { useState } from 'react';

interface Props {
  unit: Unit;
}

const LeadForm: FC<Props> = ({ unit }) => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  return showSuccessMessage ? (
    <div className="bg-sage-50 border border-sage-200 text-sage-800 px-4 py-3 rounded-none">
      <div className="flex items-center">
        <svg className="w-5 h-5 mr-2 text-sage-600" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clipRule="evenodd"
          />
        </svg>
        <div>
          <p className="text-sm font-medium">Thank you!</p>
          <p className="text-xs">We&apos;ll be in touch soon.</p>
        </div>
      </div>
    </div>
  ) : (
    <ScheduleTourForm
      className="space-y-3"
      onSuccess={() => setShowSuccessMessage(true)}
      unit={unit}
      submitButtonText="Send Message"
    />
  );
};

export default LeadForm;
